<template>
  <div class="wrapper">
    <div v-if="authResult.status === 1">
      <div class="carry-banner">
        <img :src="require('@/assets/images/carry/banner.jpg')" alt="" class="banner-img">
      </div>
      <div class="carry-container">
        <div class="carry-order">
          <van-swipe
            class="swipe-order"
            :show-indicators="false"
            :autoplay="5000"
            :vertical="true"
          >
            <van-swipe-item v-for="(item,index) in orderList" :key="index">
              <div class="order-card bg-box">
                <div class="card-top">
                  <span class="time">下单时间：{{ item.orderTime }}</span>
                  <span class="order-number">订单编号：{{ item.orderNumber }}</span>
                </div>
                <div class="card-center">
                  <div class="point-item">
                  <span class="icon-box">
                    <i class="icon"></i>
                    <em class="text">起点</em>
                  </span>
                    <span class="text">{{ item.startPoint }}</span>
                  </div>
                  <div class="point-item">
                  <span class="icon-box">
                    <i class="icon"></i>
                    <em class="text">终点</em>
                  </span>
                    <span class="text">{{ item.endPoint }}</span>
                  </div>
                </div>
                <div class="card-bottom">
                  <div class="tag-box">
                    <span class="tag-item" v-for="(subItem, subIndex) in item.tagItems" :key="subIndex">{{subItem}}</span>
                  </div>
                  <strong class="card-freight">
                    <span class="price">{{ item.freight }}</span>
                    <span class="text">元</span>
                  </strong>
                </div>
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
        <!-- 加入条件 -->
        <div class="carry-condition">
          <div class="carry-title"></div>
          <div class="condition-content bg-box">
            <div class="top-title">
              <i class="icon"></i>
              <span class="text">要求（详情见卡友须知）</span>
            </div>
            <div class="condition-list">
              <div class="list-item">
                <span class="dot"></span>
                <span class="text">拥有一台江淮轻卡（箱式或平板，车长3.8米—4.2米）。</span>
              </div>
              <div class="list-item">
                <span class="dot"></span>
                <span class="text">具备搬家经验和拆装技能，懂得物品拆装技巧。</span>
              </div>
              <div class="list-item">
                <span class="dot"></span>
                <span class="text">至少有2名搬运工。</span>
              </div>
              <div class="list-item">
                <span class="dot"></span>
                <span class="text">常驻地区为北京、石家庄、天津、重庆、上海、西安、郑州、沈阳、长春、吉林、青岛、武汉
、长沙、南京、广州、东莞、中山、佛山、惠州、柳州、南宁、深圳、珠海、昆明，其他区域将陆续开放，敬请期待。</span>
              </div>
              <!--              <div class="click-to-open" @click="handleClick">点击查看更多</div>-->
            </div>
            <!--            <div class="top-title">-->
            <!--              <i class="icon"></i>-->
            <!--              <span class="text">车型要求</span>-->
            <!--            </div>-->
            <!--            <div class="condition-list">-->
            <!--              <div class="list-item">-->
            <!--                <span class="dot"></span>-->
            <!--                <span class="text">具备运营能力的江淮轻卡</span>-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
        </div>
        <!-- 加入流程 -->
        <div class="carry-process">
          <div class="carry-title"></div>
          <div class="process-content bg-box">
            <!--<div class="process-item process-item1">
              <i class="icon"></i>
              <p class="text">司机认证</p>
            </div>
            <div class="process-icon icon1"></div>
            <div class="process-item process-item2">
              <i class="icon"></i>
              <p class="text">信息审核</p>
            </div>
            <div class="process-icon icon2"></div>
            <div class="process-item process-item3">
              <i class="icon"></i>
              <p class="text">通知结果(电话)</p>
            </div>
            <div class="process-icon icon3"></div>
            <div class="process-item process-item4">
              <i class="icon"></i>
              <p class="text">线下派单</p>
            </div>-->
            <div class="process-img"></div>
          </div>
        </div>
        <!-- 司机认证 -->
        <div class="carry-driver">
          <div class="carry-title"></div>
          <div class="driver-form bg-box">
            <van-form
              ref="carryForm"
              @submit="addCarry"
              :show-error-message="false">
              <van-field
                v-model="form.userName"
                name="用户名"
                label="用户名"
                placeholder="请填写您的姓名"
                autocomplete="off"
                :rules="userNameRules"
              />
              <van-field
                v-model="form.phone"
                name="电话"
                label="电话"
                placeholder="请填写您的手机号"
                autocomplete="off"
                :rules="phoneRules"
              />
              <van-field
                v-model="form.areaName"
                name="地区"
                label="地区"
                placeholder="请选择所在地区"
                :readonly="true"
                :rules="[{ required: true, message: '请选择所在地区', trigger: 'change' }]"
                @click="clickShowArea"
              />
              <van-field
                v-model="form.carLength"
                name="车长"
                label="车长"
                placeholder="请选择车长"
                :rules="[{ required: true, message: '请选择车长', trigger: 'change' }]"
                :readonly="true"
                @click="clickShowCarLength"
              />
              <div class="form-item-checkbox">
                <van-checkbox
                  v-model="form.agreement"
                  :rules="[{ required: true, message: '请阅读须知', trigger: 'change' }]"
                  :icon-size="16"
                  class="checkbox-item">
                </van-checkbox>
                <span class="text" @click="showAgreementPopup">卡友须知</span>
              </div>
              <div class="form-item-submit">
                <van-button
                  round block
                  type="info"
                  native-type="submit"
                  class="form-submit"
                >
                  我要加入
                </van-button>
              </div>
            </van-form>
            <van-popup v-model="showAreaPopup" round position="bottom">
              <van-picker
                show-toolbar
                :columns="areaData"
                @cancel="showAreaPopup = false"
                @confirm="handleSelectArea"
              />
            </van-popup>
            <van-popup v-model="showCarLenPopup" round position="bottom">
              <van-picker
                show-toolbar
                :columns="carLengthData"
                @cancel="showCarLenPopup = false"
                @confirm="handleSelectCar"
              />
            </van-popup>
          </div>
        </div>
      </div>
      <popup-box ref="popupBox"></popup-box>
    </div>
    <success
      v-if="authResult.status === 0"
      @reAuth="onReAuth"
    >
    </success>
  </div>
</template>

<script>
import { getAuthResult, addCarry, getCarryInfo } from '@/api/carry'
import Success from './components/Success.vue'
import PopupBox from './components/PopupBox.vue'

export default {
  name: 'carry',
  components: {
    Success,
    PopupBox
  },
  data() {
    return {
      authResult: {
        status: -1 // 0 未认证 1 已认证
      },
      orderList: [{
        orderTime: '8:22',
        orderNumber: 24989943,
        startPoint: '江汉区政府大楼',
        endPoint: '蔡甸区桐湖学校',
        tagItems: ['帅铃', '车长4.2米'],
        freight: 245
      }, {
        orderTime: '9:15',
        orderNumber: 24698238,
        startPoint: '金轮大厦(一楼门卫)',
        endPoint: '马龙小学',
        tagItems: ['骏铃', '车长4.2米'],
        freight: 216
      }, {
        orderTime: '9:43',
        orderNumber: 25075621,
        startPoint: '星城国际5栋',
        endPoint: '东六路工业城-东区',
        tagItems: ['恺达', '车长3.8米'],
        freight: 285
      }, {
        orderTime: '10:03',
        orderNumber: 24093398,
        startPoint: '欧亚国际(5层502室)',
        endPoint: '西安市蓬湖区莲湖路小学',
        tagItems: ['康铃', '车长4.2米'],
        freight: 345
      }],
      form: {
        userName: '',
        phone: '',
        provinceName: '',
        cityName: '',
        areaName: '',
        carLength: '',
        agreement: true
      },
      userNameRules: [{
        required: true,
        message: '请填写您的姓名',
        trigger: 'onBlur'
      }, {
        // 自定义校验规则
        validator: (value) => /^[a-zA-Z0-9\u4e00-\u9fa5]{1,10}$/
          .test(value),
        message: '请填写正确格式的手机号码',
        trigger: 'onBlur'
      }],
      phoneRules: [{
        required: true,
        message: '请填写您的手机号',
        trigger: 'onBlur'
      }, {
        // 自定义校验规则
        validator: (value) => /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/
          .test(value),
        message: '请填写正确格式的手机号码',
        trigger: 'onBlur'
      }],
      showAreaPopup: false,
      areaData: [
        {
          text: '北京市',
          children: [{
            text: '北京市'
          }]
        },
        {
          text: '天津市',
          children: [{
            text: '天津市'
          }]
        },
        {
          text: '河北省',
          children: [{
            text: '石家庄市'
          }]
        },
        {
          text: '辽宁省',
          children: [{
            text: '沈阳市'
          }]
        },
        {
          text: '吉林省',
          children: [{
            text: '长春市'
          }, {
            text: '吉林市'
          }]
        },
        {
          text: '上海市',
          children: [{
            text: '上海市'
          }]
        },
        {
          text: '江苏省',
          children: [{
            text: '南京市'
          }]
        },
        {
          text: '山东省',
          children: [{
            text: '青岛市'
          }]
        },
        {
          text: '河南省',
          children: [{
            text: '郑州市'
          }]
        },
        {
          text: '湖北省',
          children: [{
            text: '武汉市'
          }]
        },
        {
          text: '湖南省',
          children: [{
            text: '长沙市'
          }]
        },
        {
          text: '广东省',
          children: [{
            text: '广州市'
          }, {
            text: '东莞市'
          }, {
            text: '中山市'
          }, {
            text: '佛山市'
          }, {
            text: '惠州市'
          }, {
            text: '深圳市'
          }, {
            text: '珠海市'
          }]
        }, {
          text: '广西壮族自治区',
          children: [{
            text: '南宁市'
          }, {
            text: '柳州市'
          }]
        },
        {
          text: '重庆市',
          children: [{
            text: '重庆市'
          }]
        },
        {
          text: '云南省',
          children: [{
            text: '昆明市'
          }]
        },
        {
          text: '陕西省',
          children: [{
            text: '西安市'
          }]
        }],
      showCarLenPopup: false,
      carLengthData: [3, 3.8, 4.2, 4.6],
      showAgreement: false,
      foldName: 'condition-list-fold'
    }
  },
  created() {
    this.getAuthResult()
  },
  methods: {
    handleClick() {
      this.foldName = 'condition-list'
    },
    getAuthResult() {
      const { userId } = this.$route.query
      if (!userId) {
        return
      }
      getAuthResult({ userId })
        .then((res) => {
          this.authResult.status = res.data
        })
        .catch((err) => {
          this.$toast(err.message)
        })
    },
    showAgreementPopup() {
      // this.showAgreement = true
      this.$refs.popupBox.openPopup()
    },
    handleSelectArea(value) {
      // eslint-disable-next-line prefer-destructuring
      this.form.provinceName = value[0]
      // eslint-disable-next-line prefer-destructuring
      this.form.cityName = value[1]
      this.form.areaName = value.join('-')
      this.showAreaPopup = false
    },
    handleSelectCar(value) {
      console.log(value)
      this.form.carLength = value
      this.showCarLenPopup = false
    },
    clickShowArea() {
      this.showAreaPopup = true
    },
    clickShowCarLength() {
      this.showCarLenPopup = true
    },
    addCarry() {
      console.log(this.form)
      this.$refs.carryForm.validate().then(() => {
        const { userId } = this.$route.query
        const {
          userName, phone, provinceName, cityName, carLength, agreement
        } = this.form
        if (!agreement) {
          this.$toast('请选择卡友须知')
          return
        }
        const params = {
          userId,
          userName,
          phone,
          provinceName,
          cityName,
          carLength
        }
        addCarry(params)
          .then(() => {
            this.authResult.status = 0
          })
          .catch((err) => {
            this.$toast(err.message)
          })
      }).catch(() => {
        this.$toast.fail('提交失败')
      })
    },
    onReAuth() {
      const { userId } = this.$route.query
      if (!userId) {
        return
      }
      this.authResult.status = 1
      getCarryInfo({ userId })
        .then((res) => {
          const {
            userName, phone, provinceName, cityName, carLength
          } = res.data
          this.form = {
            userName,
            phone,
            provinceName,
            cityName,
            areaName: `${provinceName}-${cityName}`,
            carLength,
            agreement: true
          }
        })
        .catch((err) => {
          this.$toast(err.message)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.carry-banner {
  width: 100%;
  height: rem(440);
  .banner-img {
    width: 100%;
    height: 100%;
  }
}
.carry-container {
  padding: rem(32);
}
.bg-box {
  background: #ECF6FF;
  border-radius: rem(24);
}
.swipe-order {
  height: rem(345);
  .order-card {
    //height: rem(318);
    padding: 0 rem(24);
    .card-top {
      display: flex;
      justify-content: space-between;
      line-height: rem(84);
      border-bottom: 1px solid #DDDDDD;
      color: #666;
      font-size: rem(26);
    }
    .card-center {
      padding: rem(26) 0;
      .point-item {
        display: flex;
        align-items: center;
        &:first-child {
          margin-bottom: rem(32);
        }
        .icon-box {
          display: block;
          width: rem(90);
          height: rem(32);
          line-height: rem(6);
          border-radius: rem(16);
          border: 1px solid #4794FD;
          text-align: center;
          margin-right: rem(24);
          background: #fff;
          .icon {
            display: inline-block;
            vertical-align: rem(-2);
            width: rem(20);
            height: rem(20);
            background: url("../../assets/images/carry/icon_dingwei01.png") no-repeat;
            background-size: contain;
          }
          .text {
            color: #4794FD;
            margin-left: rem(8);
            font-style: normal;
            font-size: rem(20);
          }
        }
        &:last-child {
          .icon-box {
            border-color: #FF902C;
            .icon {
              background: url('../../assets/images/carry/icon_dingwei02.png') no-repeat;
              background-size: contain;
            }
            .text {
              color: #FF902C;
            }
          }
        }
        .text {
          color: #333;
          font-size: rem(18);
        }
      }
    }
    .card-bottom {
      display: flex;
      justify-content: space-between;
      line-height: rem(84);
      border-top: 1px solid #DDDDDD;
      font-size: rem(20);
      .tag-box {
        .tag-item {
          background: rgba(216, 38, 38, 0.16);
          padding: rem(6) rem(12);
          border-radius: rem(8);
          margin-right: rem(16);
          color: #D82626;
        }
      }
      .card-freight {
        .price {
          font-size: rem(40);
          font-weight: 700;
          color: #D82626;;
        }
        .text {
          font-size: rem(26);
          color: #333;
          font-weight: 500;
        }
      }
    }
  }
}
.carry-title {
  width: rem(686);
  height: rem(88);
  background: url('../../assets/images/carry/tit01.png');
  background-size: cover;
}
.carry-condition {
  margin-top: rem(32);
  .condition-content {
    margin-top: rem(-24);
    padding: 0 rem(34) rem(44) rem(34);
    overflow: hidden;
    .top-title {
      display: flex;
      align-items: center;
      height: rem(124);
      .icon {
        width: rem(34);
        height: rem(36);
        background-image: url('../../assets/images/carry/icon_sj.png');
        background-size: contain;
      }
      .text {
        margin-left: rem(22);
        font-size: rem(32);
        font-weight: 500;
        font-family: 'Source Han Sans CN';
      }
    }
    .condition-list {
      padding-left: rem(25);
      .list-item {
        display: flex;
        align-items: flex-start;
        .dot {
          width: rem(8);
          height: rem(8);
          margin-top: rem(20);
          background: #556171;
          border-radius: 50%;
          margin-right: rem(24);
          flex-shrink: 0;
        }
        .text {
          line-height: rem(48);
          color: #556171;
          font-size: rem(28);
        }
      }
    }
    .condition-list-fold {
      padding-left: rem(25);
      height: rem(200);
      .list-item {
        display: flex;
        align-items: flex-start;
        .dot {
          width: rem(8);
          height: rem(8);
          margin-top: rem(20);
          background: #556171;
          border-radius: 50%;
          margin-right: rem(24);
          flex-shrink: 0;
        }
        .text {
          line-height: rem(48);
          color: #556171;
          font-size: rem(28);
        }
      }
      .click-to-open{
        font-size: rem(10);
        align-items: center;
        height: rem(100);
        width: rem(600);
        position: absolute;
        margin-left: auto;
        margin-right: auto;
        bottom: rem(50);
        background: linear-gradient(180deg, rgba(207,227,255,0) 0%, rgb(207,227,255) 100%);
      }
    }
  }
}
.carry-process {
  margin-top: rem(32);
  .carry-title {
    background: url('../../assets/images/carry/tit02.png');
    background-size: cover;
  }
  .process-content {
    position: relative;
    margin-top: rem(-24);
    padding: rem(50) rem(32) rem(50) rem(8);
    .process-img {
      width: rem(686);
      height: rem(458);
      background: url('../../assets/images/carry/img_process.png');
      background-size: cover;
    }
    /*.process-item {
      display: inline-block;
      width: rem(220);
      .icon {
        display: block;
        width: rem(80);
        height: rem(80);
        background-size: contain !important;
        margin: 0 auto;
      }
      .text {
        color: #333;
        font-size: rem(32);
        font-family: 'Source Han Sans CN';
        text-align: center;
      }
      &.process-item1 {
        .icon {
          background-image: url('../../assets/images/carry/icon01.png');
        }
      }
      &.process-item2 {
        .icon {
          background-image: url('../../assets/images/carry/icon02.png');
        }
      }
      &.process-item3 {
        .icon {
          background-image: url('../../assets/images/carry/icon03.png');
        }
      }
      &.process-item4 {
        .icon {
          background-image: url('../../assets/images/carry/icon04.png');
        }
      }
    }
    .process-icon {
      display: inline-block;
      width: rem(58);
      height: rem(24);
      background-size: contain;
      &.icon1 {
        background-image: url('../../assets/images/carry/icon_jt01.png');
      }
      &.icon2 {
        width: rem(24);
        height: rem(58);
        background-image: url('../../assets/images/carry/icon_jt02.png');
      }
      &.icon3 {
        background-image: url('../../assets/images/carry/icon_jt03.png');
      }
    }*/
  }
}
.carry-driver {
  margin-top: rem(32);
  .carry-title {
    background: url('../../assets/images/carry/tit03.png');
    background-size: cover;
  }
  .driver-form ::v-deep{
    margin-top: rem(-24);
    padding: rem(24) rem(32);
    .van-cell {
      height: rem(96);
      border: 1px solid #5FA3F9;
      background: #F6FBFF;
      border-radius: rem(12);
      margin-bottom: rem(24);
      font-size: rem(30);
      .van-field__label {
        width: rem(126);
      }
    }
    .van-checkbox {
      .van-checkbox__label {
      }
    }
    .form-item-checkbox {
      display: flex;
      .text {
        margin-left: rem(10);
        color: #5FA3F9;
        font-size: rem(30);
      }
    }
    .form-item-submit {
      margin-top: rem(30);
      .form-submit {
        background: linear-gradient(0deg, #5FDEF9, #5FA3F9);
        border-radius: rem(12);
        border: none;
        .van-button__text {
          font-size: rem(32);
          font-family: 'Source Han Sans CN';
          font-weight: 700;
        }
      }
    }
  }
}
</style>
